import Vue from "vue";
import Vuex from "vuex";
// npm install --save vuex@3.6.2

import listPictures from "./listPictures";
import options from "./options";
import admin from "./admin";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    listPictures: listPictures,
    options: options,
    admin: admin,
  },
});
